import 'jquery-match-height'

/*
 *
 * ----------------------------------------------- */
jQuery(function($) {
  $(window).on('load scroll', function () {
    $('[data-mh-window-load]').matchHeight({
      // byRow: true,
      property: 'min-height'
      // target: null,
      // remove: false
    })
  });
});

/*
 * For nested child elements
 * ----------------------------------------------- */
jQuery(function($) {
  $(window).on('load scroll', function () {
    $('.row').each(function () {
      $(this).find('.nested').matchHeight({
        // byRow: true,
        property: 'min-height'
        // target: null,
        // remove: false
      })
    })
  });
});
